export default __webpack_public_path__ + "static/media/store-app.c2ba04c9.png";